<script>
    import { createEventDispatcher } from 'svelte';
    import { network } from '../stores.js';

    export let idKontr = 0;

    const dispatch = createEventDispatcher();

    let name = '';
    let saveError = '';
    let saveLoading = false;

    function escape(v) {
        return (v ?? '').replace(/'/g, "''");
    }

    function reset() {
        name = '';
        saveError = '';
    }

    function close() {
        reset();
        dispatch('close');
    }

    async function saveProj() {
        saveError = '';
        if (!name.trim()) {
            saveError = 'Укажите название проекта';
            return;
        }
        if (!idKontr) {
            saveError = 'Сначала выберите клиента';
            return;
        }

        saveLoading = true;
        try {
            const sql = `
                EXEC addProject
                    @kod = N'',
                    @name = N'${escape(name.trim())}',
                    @osn = 0,
                    @template = N'',
                    @actualnost = 1,
                    @idKontr = '${escape(String(idKontr))}'
            `;

            const rawResult = await network.proxy(sql, false);
            const result = Array.isArray(rawResult) ? rawResult[0] : rawResult;
            const id = result?.id;

            if (!id) {
                saveError = 'Проект сохранён, но не удалось получить ID.';
                return;
            }

            dispatch('created', { id: +id, name: name.trim() });
            reset();
        } catch (e) {
            console.error('[saveProj] ERROR:', e);
            saveError = 'Ошибка: ' + e.message;
        } finally {
            saveLoading = false;
        }
    }
</script>

<div
    class="modal-backdrop fade show"
    role="button"
    tabindex="-1"
    aria-label="Закрыть"
    on:click={close}
    on:keydown={(e) => e.key === 'Escape' && close()}
></div>
<div class="modal fade show new-proj-modal" style="display: block;" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Новый проект</h5>
                <button type="button" class="btn-close" aria-label="Закрыть" on:click={close}></button>
            </div>

            <div class="modal-body">
                <div class="form-group boxed">
                    <label class="form-label" for="proj-name">Название</label>
                    <input
                        id="proj-name"
                        type="text"
                        class="form-control"
                        placeholder="Название проекта"
                        bind:value={name}
                        maxlength="100"
                        on:keydown={(e) => e.key === 'Enter' && saveProj()}
                    />
                    {#if saveError}
                        <div class="field-error">{saveError}</div>
                    {/if}
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" on:click={close} disabled={saveLoading}>
                    Отмена
                </button>
                <button type="button" class="btn btn-primary" on:click={saveProj} disabled={saveLoading}>
                    {saveLoading ? 'Сохранение...' : 'Сохранить'}
                </button>
            </div>
        </div>
    </div>
</div>

<style>
    .new-proj-modal { z-index: 1055; }
    .modal-backdrop { z-index: 1050; }
    .form-label { font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 6px; display: block; }
    .form-control { border-radius: 12px; border: 1px solid #d8dde3; min-height: 44px; width: 100%; }
    .form-group { margin-bottom: 12px; }
    .field-error { margin-top: 6px; font-size: 12px; color: #c62828; }
    .modal-footer { display: flex; justify-content: flex-end; gap: 8px; }
</style>
